import { faChevronCircleLeft } from '@fortawesome/pro-regular-svg-icons';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { Drawer, useTheme } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Toolbar from '@material-ui/core/Toolbar';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import { CustomButton } from 'commons/Button/CustomButton';
import CustomIcon from 'commons/Icon/CustomIcon';
import LocalizedText from 'commons/LocalizedText/LocalizedText';
import { CustomTooltip } from 'commons/Tooltip/CustomTooltip';
import SearchBar from 'components/Header/SearchBar';
import useMobile from 'hook/UseMobile';
import useQueryState from 'hook/UseQueryState';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ParamTypes } from 'utils/constants/param.type';
import { getAssetUrl } from 'utils/helpers/AssetsHelper';
import { useAuthContext } from "hook/AuthProvider";
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  headerTitle: {
    marginLeft: 10,
    flexGrow: 1
  },
  imgResize: {
    margin: 3,
    marginLeft: 20,
    width: 91,
    height: 66
  },
  backButton: {
    color: theme.palette.common.white
  },
  searchDrawer: {
    position: "absolute !important" ,
    top: '75px !important',
    "& .MuiBackdrop-root": {
      position: "absolute"
    },
    "& .MuiDrawer-paper": {
      position: "absolute",
      background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.dark})`
    }
  }
}));

const HideOnScroll = (props) => {
  const { children } = props;
  const trigger = useScrollTrigger();
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
};

const BasicHeader = ({ titleMobile, titlePC, logoutLabel="logout", useTranslation=true }) => {
  const history = useHistory();
  const classes = useStyles();
  const isMobile = useMobile();
  const theme = useTheme();
  const [canGoBack] = useQueryState('back', false, ParamTypes.BOOLEAN);
  const [displaySearch, setDisplaySearch] = useState(false);
  const {logOut} = useAuthContext();

  const Text = useTranslation ? LocalizedText : Typography;

  return (
    <HideOnScroll>
      <AppBar>
        <Drawer anchor='top' className={classes.searchDrawer} onClose={() => setDisplaySearch(false)} open={displaySearch}>
          <SearchBar setDisplaySearch={setDisplaySearch}/>
        </Drawer>
        <Toolbar>
          {
            canGoBack && !isMobile && (
              <CustomTooltip title="goBackHistory">
                <IconButton className={classes.backButton} onClick={() => history.goBack()}>
                  <CustomIcon icon={faChevronCircleLeft} />
                </IconButton>
              </CustomTooltip>
            )
          }
          <Text className={classes.headerTitle} variant="h5">
            {isMobile ? titleMobile : titlePC}
          </Text>
          <IconButton onClick={() => setDisplaySearch(!displaySearch)}>
            <CustomIcon
              color={theme.palette.common.white}
              icon={faSearch}
            />
          </IconButton>
          <CustomButton
            onClick={() => logOut()}
            variant="header"
          >
            <Text variant="inherit">{logoutLabel}</Text>
          </CustomButton>
          {
            !isMobile && <img alt="Logo" className={classes.imgResize} src={getAssetUrl("/assets/images/ECC_transparent.png")} />
          }
        </Toolbar>
      </AppBar>
    </HideOnScroll>
  );
};

export default BasicHeader;